/* The ONE which makes it all possible ;) ! */
const URL_SPECIAL_CSRF_GET = '/api/special/csrf'

/* Endpoint for fetching the path of the customer's logo */
const URL_COMMON_CUSTOMER_LOGO_GET = '/api/common/params/logo'

/* List of all API endpoints: these are used in both axios call and mock */
const URL_SPECIAL_SIGNIN_POST_PARAMETERIZED = '/api/special/signin?lang=%1'
const URL_SPECIAL_SSO_SIGNIN_GET = '/api/special/signinSso?lang=%1&redirect_url=%2'
const URL_SPECIAL_SSO_STATUS_GET = '/api/special/statusSso?lang=%1'
const URL_SPECIAL_VERIFYQR_POST_PARAMETERIZED = '/api/special/verifyQr?lang=%1&token=%2'
const URL_SPECIAL_SIGNOUT_POST = '/api/special/signout'

/* Commons */
const URL_COMMON_STORES_GET = '/api/common/userparams/'
const URL_COMMON_STORES_PUT = '/api/common/userparams/'
const URL_COMMON_IMAGES_GET = '/api/common/images/'
const URL_COMMON_AIRCRAFT_LIST_ATA_GET = '/api/common/aircraft/ata'
const URL_COMMON_QUALIFICATIONS = '/api/common/qualifications'
const URL_COMMON_LOCATION_LIST_COMPANIES_GET = '/api/common/location/companies'
const URL_COMMON_LOCATION_LIST_STORES_FOR_COMPANY_GET = '/api/common/location/stores?company=%1'
const URL_COMMON_LOCATION_LIST_STORES = '/api/common/location/stores'
const URL_COMMON_LOCATION_LIST_SERVICES_FOR_COMPANY_AND_STORE_GET = '/api/common/location/services?company=%1&store=%2'
const URL_COMMON_CUSTOMISATION_WO_ISSUER_GET = '/api/common/customisation/woIssuer'
const URL_COMMON_PN_GET = '/api/common/pn?lang=%1&pn=%2'
// Search PN: 3rd parameter is an optional sequence of <pnTypes>
const URL_COMMON_PN_SEARCH_GET_PARAMETERIZED = '/api/common/pn/search?pnContains=%1&designationContains=%2%3&avnumap=%4'
const URL_COMMON_SN_SEARCH_FOR_PN_GET_PARAMETERIZED = '/api/common/sn/search?pn=%1&avnumap=%2'

const URL_COMMON_LIST_CONTROLCODES_GET = '/api/common/controlCodes'
const URL_COMMON_LIST_TASKCODES_GET = '/api/common/taskCodes'
const URL_COMMON_LIST_WORKSTATIONS_GET = '/api/common/workStations'
const URL_COMMON_LIST_PHASES_GET = '/api/common/phases'
const URL_COMMON_LIST_ACZONES_GET = '/api/common/acZones'
const URL_COMMON_NON_PERFORMANCE_CODES_GET = '/api/common/nonPerformanceCodes'
const URL_COMMON_LIST_MEL_CODES = '/api/common/melCodes?avnumap=%1'
const URL_COMMON_LIST_MEL_ITEMS = '/api/common/melItems?avnumap=%1'
const URL_COMMON_LIST_PERSONNEL = '/api/common/staff'
const URL_COMMON_LIST_LINKEDDOCTYPES = '/api/common/linkedDocTypes'
const URL_COMMON_LIST_DOCTYPES = '/api/common/docTypes'
const URL_COMMON_LIST_PROTOCOLS = '/api/common/protocols'

/* Pages */
const URL_FLEETPAN_AIRCRAFTS_GET = '/api/fleetpan/aircrafts'
const URL_FLEETPAN_HIL_GET = '/api/fleetpan/hil'
const URL_FLEETPAN_PPPR_GET = '/api/fleetpan/pppr'
const URL_FLEETPAN_OE_GET = '/api/fleetpan/oe'

const URL_WPSTATUS_PLANNING_GET = '/api/workpackage/planning'
const URL_WPSTATUS_PROGRESSION_GET = '/api/workpackage/progress'
const URL_WPSTATUS_PROGRESS_BY_TYPE_GET = '/api/workpackage/progressbytype'
const URL_WPSTATUS_WORKLOAD_GET = '/api/workpackage/workload'
const URL_WPSTATUS_VISIT_SUMMARY_GET = '/api/workpackage/summary'
const URL_WPSTATUS_LIST_TASKS_WO_GET = '/api/workpackage/details'
const URL_WPSTATUS_LIST_TASKS_AW_GET = '/api/workpackage/addwrk'
const URL_WPSTATUS_OE_GET = ''

const URL_ORDERS_GET = '/api/orders'
const URL_ORDER_GET = '/api/orders/order'
const URL_ORDER_PDF_GET = '/api/orders/pdf'
const URL_ORDER_REFUSE_PUT = '/api/orders/refuse'
const URL_ORDER_VALIDATORS_GET = 'api/orders/validator'
const URL_ORDER_VALIDATOR_PUT = 'api/orders/validator'
const URL_ORDER_VALIDATE_PUT = 'api/orders/validate'

const URL_CRM_GET = '/api/crm'
const URL_CRM_FUELS_GET = '/api/crm/fuel'
const URL_CRM_FUEL_DELETE = '/api/crm/fuel'
const URL_CRM_FUEL_TYPES_GET = '/api/crm/fuelTypes'
const URL_CRM_FUEL_TYPES_BY_CODE_GET_PARAMETERIZED = '/api/crm/fuelTypes?fuelType=%scolumn=C'
const URL_CRM_FUEL_TYPES_BY_LABEL_GET_PARAMETERIZED = '/api/crm/fuelTypes?fuelType=%scolumn=L'
const URL_CRM_FLIGHT_TYPES_GET = '/api/crm/flightTypes'
const URL_CRM_FLIGHT_TYPES_BY_CODE_GET_PARAMETERIZED = '/api/crm/flightTypes?flightType=%scolumn=C'
const URL_CRM_FLIGHT_TYPES_BY_LABEL_GET_PARAMETERIZED = '/api/crm/flightTypes?flightType=%scolumn=L'
const URL_CRM_DELAY_CODES_GET = '/api/crm/delayCodes'
const URL_CRM_DELAY_CODES_BY_CODE_GET_PARAMETERIZED = '/api/crm/delayCodes?search=%scolumn=C'
const URL_CRM_DELAY_CODES_BY_LABEL_GET_PARAMETERIZED = '/api/crm/delayCodes?search=%scolumn=L'
const URL_CRM_AC_GET = '/api/crm/aircrafts'
const URL_CRM_WORKORDERS_GET_PARAMETERIZED = '/api/crm/workorders'
const URL_CRM_BYFLIGHT_GET = '/api/crm/flight'
const URL_CRM_BYFLIGHT_LAST_GET = '/api/crm/last'
const URL_CRM_BYFLIGHT_CREATE_POST = 'api/crm'
const URL_CRM_FUEL = 'api/crm/fuel'

const URL_WORKORDER_POST = '/api/workorder'
const URL_WORKORDER_GET = '/api/workorder'
const URL_WORKORDER_SUBTYPES_MC_GET = 'api/workorder/subTypes'
const URL_WORKORDER_REQUIRED_TOOLS_INGREDIENT_TYPES_GET = '/api/common/pn/pnTypes'
const URL_WORKORDER_REQUIRED_TOOLS_GET = '/api/workorder/requiredTools'
const URL_WORKORDER_REQUIRED_TOOLS_DELETE = '/api/workorder/requiredTools'
const URL_WORKORDER_REQUIRED_TOOLS_CU = '/api/workorder/requiredTools'
const URL_WORKORDER_USED_TOOLS_GET = '/api/workorder/usedTools'
const URL_WORKORDER_USED_TOOLS_DELETE = '/api/workorder/usedTools'
const URL_WORKORDER_USED_TOOLS_POST = '/api/workorder/usedTools'
const URL_WORKORDER_MANHOUR_GET = '/api/workorder/manhour'
const URL_WORKORDER_MANHOUR_DELETE = '/api/workorder/manhour'
const URL_WORKORDER_MANHOUR_POST_PUT = '/api/workorder/manhour/manual'
const URL_WORKORDER_MANHOUR_AUTO_POST_PARAMETERIZED = '/api/workorder/manhour/scan?oenumdoc=%1&lang=%2'
const URL_WORKORDER_PERSONNEL_SEARCH_GET = 'api/workorder/staff/search'
const URL_WORKORDER_STAFF_QUALIFICATIONS_GET = 'api/workorder/staff/qualifications'
const URL_WORKORDER_LINKED_DOCS_GET = '/api/workorder/linkedDocs'
const URL_WORKORDER_LINKED_DOCS_DELETE = '/api/workorder/linkedDocs'
const URL_WORKORDER_LINKED_DOCS_POST = '/api/workorder/linkedDocs'
const URL_WORKORDER_DISPLAY_DOC_GET_PARAMETERIZED =
  '/api/workorder/document?oenumdoc=%1&codeType=%2&typeDocSb=%3&protocol=%4&reference=%5&revision=%6&item=%7'
const URL_WORKORDER_INSTALLATION_REMOVAL_GET = '/api/workorder/installationRemoval'
const URL_WORKORDER_INSTALLATION_REMOVAL_POST = '/api/workorder/installationRemoval'
const URL_WORKORDER_CREATE_POST = '/api/workorder'
const URL_WORKORDER_EXEC_NO_COMPLETION_PUT = '/api/workorder/noComplete'
const URL_WORKORDER_EXEC_COMPLETION_PUT = '/api/workorder/perform'
const URL_WORKORDER_EXEC_HIL_PUT = '/api/workorder/defer'

const URL_STOCK_GET = '/api/stocks/search'
const URL_STOCK_INTERCHANGEABLE_GET = '/api/stocks/interchangeables'

const URL_TEST_AIRCRAFTS = '/api/aircraft/v1/aircraft'

const URL_APIS = {
  URL_SPECIAL_CSRF_GET,
  URL_COMMON_CUSTOMER_LOGO_GET,
  URL_SPECIAL_SIGNIN_POST_PARAMETERIZED,
  URL_SPECIAL_SSO_SIGNIN_GET,
  URL_SPECIAL_SSO_STATUS_GET,
  URL_SPECIAL_VERIFYQR_POST_PARAMETERIZED,
  URL_SPECIAL_SIGNOUT_POST,
  URL_COMMON_STORES_GET,
  URL_COMMON_STORES_PUT,
  URL_COMMON_IMAGES_GET,
  URL_COMMON_QUALIFICATIONS,
  URL_COMMON_AIRCRAFT_LIST_ATA_GET,
  URL_COMMON_LOCATION_LIST_COMPANIES_GET,
  URL_COMMON_LOCATION_LIST_STORES_FOR_COMPANY_GET,
  URL_COMMON_LOCATION_LIST_STORES,
  URL_COMMON_LOCATION_LIST_SERVICES_FOR_COMPANY_AND_STORE_GET,
  URL_COMMON_CUSTOMISATION_WO_ISSUER_GET,
  URL_COMMON_PN_GET,
  URL_COMMON_PN_SEARCH_GET_PARAMETERIZED,
  URL_COMMON_SN_SEARCH_FOR_PN_GET_PARAMETERIZED,
  URL_COMMON_LIST_CONTROLCODES_GET,
  URL_COMMON_LIST_TASKCODES_GET,
  URL_COMMON_LIST_WORKSTATIONS_GET,
  URL_COMMON_LIST_PHASES_GET,
  URL_COMMON_LIST_ACZONES_GET,
  URL_COMMON_NON_PERFORMANCE_CODES_GET,
  URL_COMMON_LIST_MEL_CODES,
  URL_COMMON_LIST_MEL_ITEMS,
  URL_COMMON_LIST_PERSONNEL,
  URL_COMMON_LIST_LINKEDDOCTYPES,
  URL_COMMON_LIST_DOCTYPES,
  URL_COMMON_LIST_PROTOCOLS,
  URL_FLEETPAN_AIRCRAFTS_GET,
  URL_FLEETPAN_HIL_GET,
  URL_FLEETPAN_PPPR_GET,
  URL_FLEETPAN_OE_GET,
  URL_WPSTATUS_PLANNING_GET,
  URL_WPSTATUS_PROGRESSION_GET,
  URL_WPSTATUS_PROGRESS_BY_TYPE_GET,
  URL_WPSTATUS_WORKLOAD_GET,
  URL_WPSTATUS_VISIT_SUMMARY_GET,
  URL_WPSTATUS_LIST_TASKS_WO_GET,
  URL_WPSTATUS_LIST_TASKS_AW_GET,
  URL_WPSTATUS_OE_GET,
  URL_ORDERS_GET,
  URL_ORDER_GET,
  URL_ORDER_PDF_GET,
  URL_ORDER_REFUSE_PUT,
  URL_ORDER_VALIDATORS_GET,
  URL_ORDER_VALIDATOR_PUT,
  URL_ORDER_VALIDATE_PUT,
  URL_CRM_GET,
  URL_CRM_FUELS_GET,
  URL_CRM_FUEL_DELETE,
  URL_CRM_FUEL_TYPES_GET,
  URL_CRM_FUEL_TYPES_BY_CODE_GET_PARAMETERIZED,
  URL_CRM_FUEL_TYPES_BY_LABEL_GET_PARAMETERIZED,
  URL_CRM_FLIGHT_TYPES_GET,
  URL_CRM_FLIGHT_TYPES_BY_CODE_GET_PARAMETERIZED,
  URL_CRM_FLIGHT_TYPES_BY_LABEL_GET_PARAMETERIZED,
  URL_CRM_DELAY_CODES_GET,
  URL_CRM_DELAY_CODES_BY_CODE_GET_PARAMETERIZED,
  URL_CRM_DELAY_CODES_BY_LABEL_GET_PARAMETERIZED,
  URL_CRM_AC_GET,
  URL_CRM_WORKORDERS_GET_PARAMETERIZED,
  URL_CRM_BYFLIGHT_GET,
  URL_CRM_BYFLIGHT_LAST_GET,
  URL_CRM_BYFLIGHT_CREATE_POST,
  URL_CRM_FUEL,
  URL_WORKORDER_POST,
  URL_WORKORDER_GET,
  URL_WORKORDER_SUBTYPES_MC_GET,
  URL_WORKORDER_REQUIRED_TOOLS_GET,
  URL_WORKORDER_REQUIRED_TOOLS_INGREDIENT_TYPES_GET,
  URL_WORKORDER_REQUIRED_TOOLS_DELETE,
  URL_WORKORDER_REQUIRED_TOOLS_CU,
  URL_WORKORDER_USED_TOOLS_GET,
  URL_WORKORDER_USED_TOOLS_POST,
  URL_WORKORDER_USED_TOOLS_DELETE,
  URL_WORKORDER_MANHOUR_GET,
  URL_WORKORDER_MANHOUR_DELETE,
  URL_WORKORDER_MANHOUR_POST_PUT,
  URL_WORKORDER_MANHOUR_AUTO_POST_PARAMETERIZED,
  URL_WORKORDER_PERSONNEL_SEARCH_GET,
  URL_WORKORDER_STAFF_QUALIFICATIONS_GET,
  URL_WORKORDER_LINKED_DOCS_GET,
  URL_WORKORDER_LINKED_DOCS_DELETE,
  URL_WORKORDER_LINKED_DOCS_POST,
  URL_WORKORDER_DISPLAY_DOC_GET_PARAMETERIZED,
  URL_WORKORDER_INSTALLATION_REMOVAL_GET,
  URL_WORKORDER_INSTALLATION_REMOVAL_POST,
  URL_WORKORDER_CREATE_POST,
  URL_WORKORDER_EXEC_NO_COMPLETION_PUT,
  URL_WORKORDER_EXEC_COMPLETION_PUT,
  URL_WORKORDER_EXEC_HIL_PUT,
  URL_TEST_AIRCRAFTS,
  URL_STOCK_GET,
  URL_STOCK_INTERCHANGEABLE_GET,
}

export default URL_APIS
